<template>
    <auth-card-template :large="isLogged">
        <card-auth>
            <div class="text-center mb-6">
                <h4 class="font-family-title font-weight-bold text-success mb-4">
                    Participe do nosso <br>Programa de Afiliados!
                </h4>
            </div>

            <div v-if="!isLogged">
                <p class="text-center">
                    Para solicitar sua participação é necessário que você já possua uma conta em nossa plataforma.
                </p>
                <div class="mt-6">
                    <router-link :to="{ path: '/auth/login', query: { redirect: '/become-affiliate' }}" class="btn btn-success btn-lg btn-block">
                        Fazer login
                    </router-link>

                    <div class="text-center mt-6">
                        Ainda não possui uma conta?<br>
                        <router-link to="/auth/register" class="text-lg font-weight-semibold" tabindex="6">Cadastre-se agora!</router-link>
                    </div>
                </div>
            </div>

            <div v-else>
                <div v-show="isFormSent">
                    <div class="text-center">
                        <p class="text-lg">
                            <span class="d-inline-block mb-3">
                                Sua solicitação foi recebida!<br>
                                Agora você pode acessar a nossa plataforma e acompanhar suas indicações através do menu
                                <strong>Afiliados</strong>.
                            </span>
                        </p>

                        <router-link
                            class="text-lg font-weight-semibold"
                            to="/"
                        >
                            Acessar painel
                        </router-link>
                    </div>
                </div>

                <form v-if="!isFormSent" @submit.prevent="requestAffiliate">
                    <form-group label="E-mail" label-for="affiliateEmail">
                        <input
                            type="text"
                            id="affiliateEmail"
                            class="form-control"
                            readonly
                            disabled
                            :value="userData.email"
                        />
                    </form-group>

                    <form-group label="Site" label-for="affiliateSite" :error="formErrors.website">
                        <input
                            type="url"
                            id="affiliateWebsite"
                            class="form-control"
                            placeholder="Endereço do seu site, blog ou canal para divulgação"
                            autofocus
                            v-model="formData.website"
                        />
                    </form-group>

                    <form-group label="Como será feita a divulgação dos produtos?" label-for="affiliateDescription" :error="formErrors.description">
                        <textarea
                            class="form-control"
                            rows="8"
                            placeholder="Informe aqui detalhes de como pretende realizar a sua divulgação, qual a sua audiência e o tamanho dela, e outros detalhes que considerar relevante..."
                            spellcheck="false"
                            v-model="formData.description">
                        </textarea>
                    </form-group>

                    <div class="mt-6">
                        <p class="text-muted text-center px-lg-4 mb-6">
                            Ao clicar em Enviar, você confirma que leu e está de acordo com as
                            <a href="https://hostoo.io/legal/programa-de-afiliados" target="_blank">regras do Programa de Afiliados da Hostoo</a>.
                        </p>
                        <button-form ref="btnAffiliate" type="submit" theme="success" class="btn-lg btn-block">Enviar</button-form>
                    </div>

                    <div class="mb-6"></div>
                </form>
            </div>
        </card-auth>
    </auth-card-template>
</template>

<script>
    import ButtonForm       from '@/components/atoms/ButtonForm'
    import FormGroup        from '@/components/molecules/FormGroup'
    import CardAuth         from '@/components/organisms/CardAuth'
    import AuthCardTemplate from '@/components/templates/AuthCardTemplate'
    import ErrorService     from '@/services/ErrorService'
    import { Api }          from '@/plugins/api'

    export default {
        components: {
            ButtonForm,
            FormGroup,
            CardAuth,
            AuthCardTemplate,
        },
        data() {
            return {
                isLogged: false,
                userData: {},
                formData: {},
                formErrors: {},
                isFormSent: false,
            }
        },
        beforeRouteEnter(to, from, next)
        {
            Api.get('/user')
                .then (response => next(vm => {
                    vm.isLogged = true;
                    vm.userData = response.data.data;
                }))
                .catch(error => next(vm => {
                    vm.isLogged = false;
                }));
        },
        methods: {

            /**
             * Solicitar participação no programa de afiliados.
             */
            requestAffiliate()
            {
                this.formErrors = {};
                this.$refs.btnAffiliate.loadingFocus();

                this.$api.post('/affiliate', this.formData)
                    .then (response => {
                        this.isFormSent = true;
                    })
                    .catch(error => {
                        ErrorService.handleFormError(error, this);
                        this.$refs.btnAffiliate.setLoading(false);
                    });
            },
        }
    }
</script>
